import { render, staticRenderFns } from "./Kelite.vue?vue&type=template&id=36a85738"
import script from "./Kelite.vue?vue&type=script&lang=js"
export * from "./Kelite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports